import { render } from "./AccountLoginView.vue?vue&type=template&id=f55ec404"
import script from "./AccountLoginView.vue?vue&type=script&lang=js"
export * from "./AccountLoginView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\_VELO\\demo-location.accen.me\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__